import TabToggle from 'components/commons/tab-toogle'
import MultipleSelect from 'components/commons/multiple-select'
import { InlineError } from 'avo-ui'

export const VoucherHighlight = ({ salePageDetail, onSearchVoucher, optionsVoucher, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'Voucher Highlight'}
            content={
                <div className={'flex flex-col w-1/2 space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Pilih Voucher</div>
                    <MultipleSelect
                        name={'vouchers'}
                        placeholder={'Search Voucher...'}
                        onSearch={onSearchVoucher}
                        value={salePageDetail?.vouchers}
                        options={optionsVoucher}
                        onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                    />
                    <InlineError className='mt-2' message={errorForm?.vouchers} />
                </div>
            }
        />
    )
}
